import { type Component, createSignal, type JSX, type ParentProps } from 'solid-js'
import Sidebar from '../sidebar/Sidebar'
import Topbar from '../topbar/Topbar'
import Footer from './Footer'
import { useError } from '../../shared/providers/error.provider'
import LoadingError from '../LoadingError'

const MainLayout: Component<ParentProps> = (props) => {
  const [isSidebarOpen, setSidebarOpen] = createSignal(false)

  const { error } = useError()
  const content = (): JSX.Element => {
    return error() ? <LoadingError /> : <>{props.children}</>
  }

  return (
    <div class="h-[100svh]">
      <Sidebar isOpen={isSidebarOpen()} onSidebarClose={() => setSidebarOpen(false)} />
      <div class="flex flex-col lg:pl-72 h-full">
        <div class="border-b border-gray-200 shadow-b-sm">
          <Topbar onSidebarOpen={() => setSidebarOpen(true)} />
        </div>

        <main class="pb-16 flex-1 bg-gray-100 relative z-0">
          <div class="h-full w-full">{content()}</div>
        </main>
        <Footer />
      </div>
    </div>
  )
}

export default MainLayout
